export default __webpack_public_path__ + "static/media/support-flag-uru.b7db76c2.svg";